module.exports = __webpack_public_path__ + "images/emoji/inbox_tray.bee891f8492aa7179f79.png";